import { FC, useContext, useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { UserContext } from '../../../Provider';
import AGButton from '../../../components/Button';
import CardToggle from '../../../components/CardToggle';
import { RolesHandle } from '../../../components/RolesHandle';
import Tooltip from '../../../components/Tooltip';
import { CommerceFirmData } from '../../../models';
import { httpGET } from '../../../utils/ajaxHelper';
import { Div } from '../commerce.styled';
import { ICardItem } from './cardItem.props';
import { CardContainer, TagOptionService } from './cardItem.styled';
import { ADMIN_ORGANIZATION } from '../../../utils/constant';

const CardItem: FC<ICardItem> = (
    {
        header,
        headerIcon,
        setShow,
        children,
        firmId,
        tagService,
        className,
        childrenClassName,
        titleTooltip,
        isShowToggleButton = false,
        isShowCollapse,
        buttonText,
        buttonTextClassName,
        SecondInfo,
        subChildren,
        subHeader,
        memberBenefirHeader,
        serviceList,
        memberChildren,
        autoToggle = false,
        secondmentDescriptions,
        firmRegion,
        isReload,
        secondmentTitle
    }
) => {
    const user = useContext(UserContext);

    const [serviceData, setServiceData] = useState<CommerceFirmData[]>([]);
    const { mutate: getSelectedServ,isLoading: getServiceLoading } = useMutation(
        (data: any) =>
            httpGET({
                url: `/FirmProfile/serviceDetail/${firmId}`,
            }),
        {
            onSuccess: (rs) => {
                setServiceData(rs.firmDatas as CommerceFirmData[]);
            },
        }
    );

    useEffect(() => {
        if (firmId && serviceData && !isReload) {
            getSelectedServ(firmId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [serviceList, firmId, isReload]);

    return (
        <CardContainer>
            <CardToggle
                isShowToggleButton={isShowToggleButton}
                isCollapse={isShowCollapse}
                autoToggle={autoToggle}
                title={
                    <Div className={`card-title ${className} justify-between !pb-0`}>

                        {getServiceLoading ? null : serviceData && serviceData.length === 0 && serviceList ? (
                            <div className="flex items-center justify-start h-[30px]">
                                <p className="text-[#637381] text-[14px]">No services found.</p>
                            </div>
                        ) : null}

                        {secondmentTitle ?
                        <div className="flex-row">
                            {secondmentTitle ? <h2 className={`text-[#333333] pb-[15px]`}>{secondmentTitle}</h2> : null}
                            <h2 className={`text-[#333333]`}>{header} {tagService ? <TagOptionService className='whitespace-pre'>{tagService}</TagOptionService> : null}</h2>
                        </div> :
                        <div className="text-[#333333]">
                        <div className="inline items-baseline align-middle">
                            <span className='inline items-baseline align-middle text-[1.1875rem] font-bold'>{header}</span>
                            {titleTooltip && (
                                <span className="inline-flex items-baseline ml-[5px] align-middle">
                                <Tooltip text={titleTooltip}/>
                                </span>
                            )}
                            </div>
                        </div>
                        }
                        

                        {serviceList === false ?
                            <RolesHandle
                                firmId={firmId}
                                fkOrgId={user!.individual!.fkOrgId}
                                roles={["Admin", "FirmCommerceManagement"]}>
                                <Div className='edit-icon' onClick={() => {
                                    setShow()
                                }}>
                                    <div className={`flex ${buttonTextClassName}`}>{headerIcon} <p>{buttonText}</p></div>
                                </Div>
                            </RolesHandle> :
                            (serviceData?.length < user?.individual.serviceMaximumQuantity!) || (firmId === ADMIN_ORGANIZATION.ID && user?.roles.includes("Admin")) ? 
                                (
                                <RolesHandle
                                    firmId={firmId ?? 0}
                                    fkOrgId={user!.individual!.fkOrgId}
                                    roles={[
                                        "Admin",
                                        "FirmCommerceManagement",
                                        "ManagingPartner",
                                    ]}
                                >
                                 {serviceList === true && <AGButton
                                        className={`flex items-center space-x-2 group w-28 ${buttonTextClassName} bg-white customDesktop:hover:bg-[#0971A2] transition-colors duration-300`}
                                        type="Primary"
                                        clasNameCus="customButton"
                                        onClick={(e) => {
                                            setShow();
                                        }}
                                    >
                                        <PlusIcon className="fill-[#0971A2] customDesktop:group-hover:fill-white" />
                                        <span className="text-[#0971A2] customDesktop:group-hover:text-white">{buttonText}</span>
                                    </AGButton>}
                                </RolesHandle>) 
                                : <></>
                        }
                    </Div>
                }
            >
                <Div className={`card mt-[5px]`}>
                    <Div className={`card-add ${childrenClassName}`}>
                        {children}
                    </Div>
                </Div>
                {SecondInfo && (
                    <>
                        {subHeader ?
                            <div>
                                <div className="card-title flex items-center space-x-[5px]">
                                    <h2 className={`text-[#333333]`}>{subHeader} </h2>
                                    {
                                        titleTooltip && <Tooltip text={titleTooltip} />
                                    }
                                </div>
                                <RolesHandle
                                    firmId={firmId}
                                    roles={["Admin", "FirmCommerceManagement"]}>
                                    <Div className='edit-icon' onClick={() => {
                                        setShow()
                                    }}>
                                        <div className={`flex ${buttonTextClassName}`}>{headerIcon} <p>{buttonText}</p></div>
                                    </Div>
                                </RolesHandle>
                                <Div className={`card mt-[5px] mb-[10px]`}>
                                    <Div className={`card-add ${childrenClassName}`}>
                                        {subChildren}
                                    </Div>
                                </Div>
                            </div> : null
                        }
                        {memberBenefirHeader ?
                            <>
                                <div className="card-title flex items-center space-x-[5px]">
                                    <h2 className='text-[#333333]'>{memberBenefirHeader} </h2>
                                    {
                                        titleTooltip && <Tooltip text={titleTooltip} />
                                    }
                                </div>
                                <RolesHandle
                                    firmId={firmId}
                                    roles={["Admin", "FirmCommerceManagement"]}>
                                    <Div className='edit-icon' onClick={() => {
                                        setShow()
                                    }}>
                                        <div className={`flex ${buttonTextClassName}`}>{headerIcon} <p>{buttonText}</p></div>
                                    </Div>
                                </RolesHandle>
                                <Div className={`card mt-[5px]`}>
                                    <Div className={`card-add ${childrenClassName}`}>
                                        {memberChildren}
                                    </Div>
                                </Div>
                            </>
                            : null
                        }
                        {
                            secondmentDescriptions && 
                            <>
                                <div className="card-title flex items-center space-x-[5px] mt-[-10px]">
                                    <h2 className='text-[#333333]'>Organization Region: {firmRegion}</h2>
                                    {
                                        titleTooltip && <Tooltip text={titleTooltip} />
                                    }
                                </div>
                                <div className="card-title flex items-center space-x-[5px]">
                                    <h2 className='text-[#333333]'>Duration and Description</h2>
                                    {
                                        titleTooltip && <Tooltip text={titleTooltip} />
                                    }
                                </div>
                                <Div className={`card mt-[5px]`}>
                                    <Div className={`card-add ${childrenClassName}`} style={{whiteSpace: "pre-line"}}>
                                        {secondmentDescriptions}
                                    </Div>
                                </Div>
                            </>
                        }
                    </>
                )}
            </CardToggle>

        </CardContainer>
    )
}

export default CardItem

export const PlusIcon = ({ className }: { className?: string }) => {
    return (
        <svg
            width="18"
            height="17"
            viewBox="0 0 18 17"
            className={className}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17.0748 7.00797H10.3598V0.292969H7.63981V7.00797H0.924805V9.72797H7.63981V16.443H10.3598V9.72797H17.0748V7.00797Z"
            />
        </svg>
    );
}
